import React, { useState } from "react";
import Banner from "../../components/section/NewHome/Banner/Banner";
import Video from "../../components/section/NewHome/Video";
import TrustedBy from "../../components/section/NewHome/TrustedBy";
import Offer from "../../components/section/NewHome/Offer";
import StepPlan from "../../components/section/NewHome/StepPlan";
import StepPlanItem from "../../components/section/NewHome/StepPlanItem/StepPlanItem";
import EvaluationTools from "../../components/section/NewHome/EvaluationTools";
import Webinars from "../../components/section/NewHome/Webinars";
import ClientSays from "../../components/section/NewHome/ClientSays";
import BusinessFuture from "../../components/section/NewHome/BusinessFuture";
import PriceingPlans from "../../components/section/NewHome/PriceingPlans";
import FeatuersBanner from "../../components/section/NewHome/FeatuersBanner";
import FeaturesPlan from "../../components/section/NewHome/FeaturesPlan";
import PricingBanner from "../../components/section/NewHome/PricingBanner";
import Faqs from "../../components/section/NewHome/Faqs";
import Footer from "../../components/section/NewHome/Footer";

const NewHome = () => {
  const [activeTab, setActiveTab] = useState("Generate");
  // const onPress = (e) => {
  //   e.preventDefault();
  //   const target = window.document.getElementById(
  //     e.currentTarget.href.split("#")[1]
  //   );
  //   if (target) {
  //     var headerOffset = 80;
  //     var elementPosition = target.getBoundingClientRect().top;
  //     var offsetPosition = elementPosition - headerOffset;

  //     window.scrollBy({
  //       behavior: "smooth",
  //       top: offsetPosition,
  //     });
  //   }
  // };

  return (
    <>
      <Banner />
      <Video />
      <TrustedBy />
      <Offer />
      <StepPlan activeTab={activeTab} setActiveTab={setActiveTab} />
      <StepPlanItem activeTab={activeTab} />
      <EvaluationTools />
      <Webinars />
      <ClientSays />
      <BusinessFuture />
      <PriceingPlans />
      <FeatuersBanner />
      <FeaturesPlan />
      <PricingBanner />
      <Faqs />
      <Footer/>
    </>
  );
};

export default NewHome;
